import React from "react";
import {
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Edit as EditIcon, DeleteOutlined } from "@mui/icons-material";
import moment from "moment";

import { StandardTableContainer, useStandardTableStyles } from "../StandardTable";

const STATUS_META = {
  pending: { label: "Pendiente", color: "warning" },
  confirmed: { label: "Confirmada", color: "info" },
  completed: { label: "Completada", color: "success" },
  cancelled: { label: "Cancelada", color: "default" },
};

const AppointmentsListPanel = ({
  appointments,
  loading,
  onEdit,
  onDelete,
}) => {
  const tableClasses = useStandardTableStyles();

  return (
    <div>
      <StandardTableContainer>
        <Table size="small" stickyHeader>
          <TableHead className={tableClasses.head}>
            <TableRow>
              <TableCell>Título</TableCell>
              <TableCell>Contacto</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Agente</TableCell>
              <TableCell align="center">Estado</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {appointments.map((a) => (
              <TableRow key={a.id} hover>
                <TableCell>{a.title}</TableCell>
                <TableCell>{a.contact?.name || "-"}</TableCell>
                <TableCell>
                  {moment(a.startAt).format("DD/MM/YYYY HH:mm")} - {moment(a.endAt).format("HH:mm")}
                </TableCell>
                <TableCell>{a.user?.name || "-"}</TableCell>
                <TableCell align="center">
                  <Chip
                    size="small"
                    label={STATUS_META[a.status]?.label || a.status}
                    color={STATUS_META[a.status]?.color || "default"}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" onClick={() => onEdit(a)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={() => onDelete(a)}>
                    <DeleteOutlined fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!loading && appointments.length === 0 && (
          <div className={tableClasses.empty}>Todavía no hay ninguna cita cargada.</div>
        )}
        {loading && (
          <div style={{ display: "flex", justifyContent: "center", padding: 16 }}>
            <CircularProgress size={22} />
          </div>
        )}
      </StandardTableContainer>
    </div>
  );
};

export default AppointmentsListPanel;
